import { ComponentType } from '@angular/cdk/portal';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  InjectionToken,
  Optional,
} from '@angular/core';
import { NgControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';

export const MAT_DIALOG_COMPONENT_TYPE = new InjectionToken(
  'MAT_DIALOG_COMPONENT_TYPE'
);

@Component({
  selector: 'bs-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: EditUserComponent,
      multi: true,
    },
  ],
})
export class EditUserComponent<T> {
  value: any;
  ngControl!: NgControl | null;
  onChange?: (value: string) => void;
  onTouched?: () => void;

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  constructor(
    public dialog: MatDialog,
    readonly changeDetectorRef: ChangeDetectorRef,
    @Optional()
    @Inject(MAT_DIALOG_COMPONENT_TYPE)
    readonly matDialogComponent: ComponentType<T>
  ) {}

  openDialog() {
    if (!this.matDialogComponent) return;

    this.dialog
      .open(this.matDialogComponent, {
        width: 'min(500px, 100%)',
        autoFocus: false,
        data: {
          client: this.value,
        },
      })
      .afterClosed()
      .subscribe((_observation) => {
        this.changeDetectorRef.detectChanges();
      });
  }
}
